import { render, staticRenderFns } from "./paginationBrandmeV2.vue?vue&type=template&id=07cc558c&scoped=true&"
import script from "./paginationBrandmeV2.vue?vue&type=script&lang=js&"
export * from "./paginationBrandmeV2.vue?vue&type=script&lang=js&"
import style0 from "./paginationBrandmeV2.vue?vue&type=style&index=0&id=07cc558c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc558c",
  null
  
)

export default component.exports